import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "call-analysis-content" }
const _hoisted_2 = {
  key: 0,
  class: "conversation-badges"
}
const _hoisted_3 = {
  key: 0,
  class: "badge badge-voicemail",
  title: "Voicemail / Automated System"
}
const _hoisted_4 = {
  key: 1,
  class: "badge badge-live",
  title: "Live Conversation"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 1,
  class: "voicemail-message"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 3,
  class: "error-text"
}
const _hoisted_10 = {
  key: 3,
  class: "section section-transcript"
}
const _hoisted_11 = { class: "transcript-header" }
const _hoisted_12 = { class: "transcript-actions" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "transcript-content"
}
const _hoisted_15 = {
  key: 4,
  class: "section section-topics"
}
const _hoisted_16 = { class: "topics-container" }
const _hoisted_17 = {
  key: 5,
  class: "section"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 6,
  class: "section"
}
const _hoisted_20 = { class: "action-items-list" }
const _hoisted_21 = {
  key: 7,
  class: "section sentiment-section"
}
const _hoisted_22 = { class: "sentiment-container" }
const _hoisted_23 = { class: "sentiment-column" }
const _hoisted_24 = { class: "sentiment-column" }
const _hoisted_25 = {
  key: 8,
  class: "section"
}
const _hoisted_26 = { class: "metadata-container" }
const _hoisted_27 = { class: "metadata-badges" }
const _hoisted_28 = {
  key: 0,
  class: "metadata-badge metadata-badge--type"
}
const _hoisted_29 = {
  key: 1,
  class: "metadata-badge metadata-badge--outcome"
}
const _hoisted_30 = {
  key: 0,
  class: "metadata-sentiment"
}
const _hoisted_31 = {
  key: 9,
  class: "section"
}
const _hoisted_32 = { class: "golden-nuggets-list" }
const _hoisted_33 = {
  key: 10,
  class: "section"
}
const _hoisted_34 = {
  key: 0,
  class: "intel-subsection"
}
const _hoisted_35 = { class: "prospect-question__text" }
const _hoisted_36 = {
  key: 0,
  class: "prospect-question__implied"
}
const _hoisted_37 = {
  key: 1,
  class: "intel-subsection"
}
const _hoisted_38 = { class: "action-items-list" }
const _hoisted_39 = {
  key: 11,
  class: "section"
}
const _hoisted_40 = {
  key: 0,
  class: "followup-row"
}
const _hoisted_41 = { class: "followup-value" }
const _hoisted_42 = {
  key: 1,
  class: "followup-row"
}
const _hoisted_43 = { class: "followup-value" }
const _hoisted_44 = {
  key: 2,
  class: "followup-actions"
}
const _hoisted_45 = { class: "action-items-list" }
const _hoisted_46 = {
  key: 12,
  class: "section followup-email-action"
}
const _hoisted_47 = {
  key: 13,
  class: "no-data-state"
}

import type { CallLogResponse } from "@/dtos/CallLog.dto";
import { toastService } from "@/utils/toast-service";
import { downloadTranscript } from "@/utils/transcript";
import { Icon } from "@iconify/vue";
import { computed, ref } from "vue";
import TranscriptViewer from "./TranscriptViewer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CallAnalysisContent',
  props: {
    callData: {},
    isLoading: { type: Boolean },
    hideFollowUpEmail: { type: Boolean }
  },
  emits: ["regenerate", "send-follow-up-email", "refresh-transcript"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const showTranscript = ref(false);
const isDownloadingTranscript = ref(false);

const summary = computed(() => props.callData?.analysis?.summary || "");
const actionItems = computed(() => props.callData?.analysis?.actionItems || null);
const topics = computed(() => props.callData?.analysis?.topics || null);
const sentiment = computed(() => props.callData?.analysis?.sentiment || null);
const transcriptUrl = computed(() => props.callData?.transcriptUrl || null);
const analysisStatus = computed(() => props.callData?.analysisStatus || null);
const transcriptStatus = computed(() => props.callData?.transcriptStatus || null);
const callMetadata = computed(() => props.callData?.analysis?.callMetadata || null);
const executiveSummary = computed(() => props.callData?.analysis?.executiveSummary || null);
const detectiveAnalysis = computed(() => props.callData?.analysis?.detectiveAnalysis || null);
const followUpStrategy = computed(() => props.callData?.analysis?.followUpStrategy || null);
const followUpEmail = computed(() => props.callData?.analysis?.followUpEmail || null);

const formattedSummaryHtml = computed(() => {
  if (!summary.value) return "";

  const lines = summary.value.split("\n");
  const result: string[] = [];
  let inList = false;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();

    if (!trimmed) {
      if (inList) {
        result.push("</ul>");
        inList = false;
      }
      continue;
    }

    if (trimmed.startsWith("**") && trimmed.endsWith("**")) {
      if (inList) {
        result.push("</ul>");
        inList = false;
      }
      const headerText = trimmed.replace(/\*\*/g, "").trim();
      result.push(`<div class="summary-header">${headerText}</div>`);
    } else if (trimmed.startsWith("- ")) {
      if (!inList) {
        result.push('<ul class="summary-list">');
        inList = true;
      }
      const itemText = trimmed.substring(2).trim();
      result.push(`<li class="summary-list-item">${itemText}</li>`);
    } else {
      if (inList) {
        result.push("</ul>");
        inList = false;
      }

      const isLikelyTopicName =
        trimmed.length < 50 &&
        !trimmed.endsWith(".") &&
        !trimmed.endsWith("?") &&
        !trimmed.endsWith("!") &&
        !trimmed.includes(". ") &&
        i + 1 < lines.length &&
        lines[i + 1]?.trim().startsWith("-");

      if (isLikelyTopicName) {
        result.push(`<div class="summary-topic-name">${trimmed}</div>`);
      } else {
        result.push(`<p class="summary-paragraph">${trimmed}</p>`);
      }
    }
  }

  if (inList) {
    result.push("</ul>");
  }

  return result.join("\n");
});

const isVoicemail = computed(() => {
  if (!props.callData) return false;
  return (
    !props.callData.isLiveConversation && props.callData.connectReason?.startsWith("Twilio AMD:")
  );
});

const hasAnalysisData = computed(() => {
  return (
    !!summary.value ||
    (actionItems.value && Array.isArray(actionItems.value) && actionItems.value.length > 0) ||
    (topics.value && Array.isArray(topics.value) && topics.value.length > 0) ||
    !!sentiment.value ||
    !!callMetadata.value ||
    !!executiveSummary.value ||
    !!detectiveAnalysis.value ||
    !!followUpStrategy.value
  );
});

function handleSendFollowUp() {
  if (!followUpEmail.value) return;
  const { subjectLine, emailBody } = followUpEmail.value;
  const hasBrTags = /<br\s*\/?>/i.test(emailBody);
  let htmlBody: string;
  if (hasBrTags) {
    htmlBody = emailBody
      .split(/(?:<br\s*\/?>\s*){2,}/i)
      .map((p: string) => `<p>${p.trim()}</p>`)
      .join("<p><br></p>");
  } else {
    htmlBody = emailBody
      .split(/\n\n+/)
      .map((p: string) => `<p>${p.replace(/\n/g, "<br>")}</p>`)
      .join("");
  }
  emit("send-follow-up-email", { subject: subjectLine, content: htmlBody });
}

async function handleTranscriptDownload() {
  if (!transcriptUrl.value || isDownloadingTranscript.value) {
    return;
  }

  isDownloadingTranscript.value = true;
  try {
    await downloadTranscript(transcriptUrl.value, props.callData ?? undefined);
  } catch (error) {
    const message = error instanceof Error ? error.message : "Failed to download transcript";
    toastService.error(message);
  } finally {
    isDownloadingTranscript.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.callData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (isVoicemail.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:phone-outline",
                  width: "14",
                  height: "14"
                }),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Voicemail / Automated System", -1))
              ]))
            : (__props.callData.isLiveConversation)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:comment-outline",
                    width: "14",
                    height: "14"
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "Live Conversation", -1))
                ]))
              : _createCommentVNode("", true),
          (__props.callData.isConnectedConversation && !isVoicemail.value)
            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                key: 2,
                class: "badge badge-connected",
                title: __props.callData.connectReason || 'Connected Conversation'
              }, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:check-circle-outline",
                  width: "14",
                  height: "14"
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Connected", -1))
              ], 8, _hoisted_5)), [
                [_directive_tooltip, __props.callData.connectReason]
              ])
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isVoicemail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("p", null, "Voicemail detected (not analyzed).", -1)
        ]))]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && analysisStatus.value && analysisStatus.value !== 'completed')
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["status-message", { 'status-message--failed': analysisStatus.value === 'failed' }])
        }, [
          (analysisStatus.value !== 'failed')
            ? (_openBlock(), _createBlock(_unref(Icon), {
                key: 0,
                icon: "mdi:loading",
                width: "18",
                height: "18",
                class: "spinning-icon"
              }))
            : _createCommentVNode("", true),
          (analysisStatus.value === 'pending')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Analysis pending..."))
            : (analysisStatus.value === 'in_progress')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Analyzing call..."))
              : (analysisStatus.value === 'failed')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:alert-outline",
                      width: "16",
                      height: "16",
                      class: "error-icon-inline"
                    }),
                    _cache[8] || (_cache[8] = _createTextVNode(" Analysis failed ", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-retry",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('regenerate')))
                    }, "Retry")
                  ]))
                : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (!isVoicemail.value && transcriptUrl.value && transcriptStatus.value === 'completed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[11] || (_cache[11] = _createElementVNode("h6", { class: "section-title" }, "Transcript", -1)),
            _createElementVNode("div", _hoisted_12, [
              (!showTranscript.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn-transcript-action btn-transcript-small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showTranscript.value = true))
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:eye-outline",
                      width: "14",
                      height: "14"
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "View", -1))
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn-transcript-action btn-transcript-action-secondary btn-transcript-small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showTranscript.value = false))
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:eye-off-outline",
                      width: "14",
                      height: "14"
                    }),
                    _cache[10] || (_cache[10] = _createElementVNode("span", null, "Hide", -1))
                  ])),
              _createElementVNode("button", {
                type: "button",
                class: "btn-transcript-action btn-transcript-small",
                disabled: isDownloadingTranscript.value,
                onClick: handleTranscriptDownload
              }, [
                (!isDownloadingTranscript.value)
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 0,
                      icon: "mdi:arrow-down-circle-outline",
                      width: "14",
                      height: "14"
                    }))
                  : (_openBlock(), _createBlock(_unref(Icon), {
                      key: 1,
                      icon: "mdi:loading",
                      width: "14",
                      height: "14",
                      class: "spinning-icon"
                    })),
                _createElementVNode("span", null, _toDisplayString(isDownloadingTranscript.value ? "Downloading..." : "Download"), 1)
              ], 8, _hoisted_13)
            ])
          ]),
          (showTranscript.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(TranscriptViewer, {
                  "transcript-url": transcriptUrl.value,
                  onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('refresh-transcript')))
                }, null, 8, ["transcript-url"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && topics.value && Array.isArray(topics.value) && topics.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "section-title" }, "Topics", -1)),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topics.value, (topic, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: "topic-chip"
              }, _toDisplayString(topic), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && summary.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "section-title" }, "Call Notes", -1)),
          _createElementVNode("div", {
            class: "formatted-summary",
            innerHTML: formattedSummaryHtml.value
          }, null, 8, _hoisted_18)
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && actionItems.value && Array.isArray(actionItems.value) && actionItems.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "section-title" }, "Action Items", -1)),
          _createElementVNode("ul", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionItems.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "action-item"
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && sentiment.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "section-title" }, "Sentiment Analysis", -1)),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "sentiment-label-text" }, "Customer Sentiment:", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["sentiment-badge", {
              'sentiment-badge-positive': sentiment.value.customer === 'Positive',
              'sentiment-badge-neutral': sentiment.value.customer === 'Neutral',
              'sentiment-badge-negative': sentiment.value.customer === 'Negative',
            }])
              }, _toDisplayString(sentiment.value.customer || "N/A"), 3)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "sentiment-label-text" }, "Sales Rep Sentiment:", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["sentiment-badge", {
              'sentiment-badge-positive': sentiment.value.salesRep === 'Positive',
              'sentiment-badge-neutral': sentiment.value.salesRep === 'Neutral',
              'sentiment-badge-negative': sentiment.value.salesRep === 'Negative',
            }])
              }, _toDisplayString(sentiment.value.salesRep || "N/A"), 3)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && callMetadata.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "section-title" }, "Call Metadata", -1)),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (callMetadata.value.type)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(callMetadata.value.type), 1))
                : _createCommentVNode("", true),
              (callMetadata.value.outcome)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(callMetadata.value.outcome), 1))
                : _createCommentVNode("", true)
            ]),
            (callMetadata.value.sentiment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(callMetadata.value.sentiment), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && executiveSummary.value && executiveSummary.value.goldenNuggets.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _cache[19] || (_cache[19] = _createElementVNode("h6", { class: "section-title" }, "Key Insights", -1)),
          _createElementVNode("ul", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(executiveSummary.value.goldenNuggets, (nugget, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                class: "golden-nugget-item"
              }, _toDisplayString(nugget), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && detectiveAnalysis.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "section-title" }, "Prospect Intel", -1)),
          (detectiveAnalysis.value.prospectQuestions && detectiveAnalysis.value.prospectQuestions.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "intel-subsection-title" }, "Questions Asked", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detectiveAnalysis.value.prospectQuestions, (q, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "prospect-question"
                  }, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(q.questionAsked), 1),
                    (q.impliedNeed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Implied need: " + _toDisplayString(q.impliedNeed), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (detectiveAnalysis.value.painPoints && detectiveAnalysis.value.painPoints.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "intel-subsection-title" }, "Pain Points", -1)),
                _createElementVNode("ul", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detectiveAnalysis.value.painPoints, (point, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: idx,
                      class: "action-item"
                    }, _toDisplayString(point), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isVoicemail.value && followUpStrategy.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "section-title" }, "Follow-Up Strategy", -1)),
          (followUpStrategy.value.suggestedAngle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "followup-label" }, "Angle:", -1)),
                _createElementVNode("span", _hoisted_41, _toDisplayString(followUpStrategy.value.suggestedAngle), 1)
              ]))
            : _createCommentVNode("", true),
          (followUpStrategy.value.openingHook)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "followup-label" }, "Opening Hook:", -1)),
                _createElementVNode("span", _hoisted_43, _toDisplayString(followUpStrategy.value.openingHook), 1)
              ]))
            : _createCommentVNode("", true),
          (followUpStrategy.value.actionItems && followUpStrategy.value.actionItems.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "followup-label" }, "Action Items:", -1)),
                _createElementVNode("ul", _hoisted_45, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followUpStrategy.value.actionItems, (item, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: idx,
                      class: "action-item"
                    }, _toDisplayString(item), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!__props.hideFollowUpEmail && !isVoicemail.value && followUpEmail.value && analysisStatus.value === 'completed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-send-followup",
            onClick: handleSendFollowUp
          }, [
            _createVNode(_unref(Icon), {
              icon: "mdi:email-send-outline",
              width: "16",
              height: "16"
            }),
            _cache[27] || (_cache[27] = _createElementVNode("span", null, "Send Follow-Up Email", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.isLoading && !hasAnalysisData.value && analysisStatus.value === 'completed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[28] || (_cache[28] = [
          _createElementVNode("p", null, "No analysis data available for this call.", -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}
}

})